import { DomainIDs } from 'common/constants/enums';

import { GlobalState } from '../store/initialState';

import { QuestionPathStateValue } from './reducer';

export const getQuestionPathState = (path: string) => (
  state: GlobalState
): QuestionPathStateValue | undefined => state[DomainIDs.QUESTION_PATH]?.[path];
